var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { POLL_TYPE, SPOILER_TYPE, TIPTAP_POLL_TYPE } from "./../../wix-rich-content-common";
const getAbsoluteUrl = (url) => url.substring(0, 5).includes("http") ? url : "http://" + url;
const hasPlugin = (pluginType, plugins) => !!(plugins == null ? void 0 : plugins.some((plugin) => plugin.type === pluginType));
const getPluginConfig = (pluginType, plugins) => {
  var _a;
  return ((_a = plugins == null ? void 0 : plugins.find((plugin) => plugin.type === pluginType)) == null ? void 0 : _a.config) || {};
};
const extractPluginsConfig = (plugins, helpers) => {
  let mergedConfig = {};
  plugins == null ? void 0 : plugins.forEach((plugin) => {
    const { type, config } = plugin;
    if (Object.keys(config).length !== 0) {
      mergedConfig = __spreadProps(__spreadValues({}, mergedConfig), { [type]: config });
    }
    if (type === SPOILER_TYPE && helpers) {
      mergedConfig[type].onViewerAction = helpers.onViewerAction;
    }
  });
  return { config: mergedConfig };
};
const hasPollsPluginInContent = (content) => {
  if (!content) {
    return false;
  }
  const nodes = content.nodes;
  return nodes == null ? void 0 : nodes.some((node) => [POLL_TYPE, TIPTAP_POLL_TYPE].includes(node.type));
};
export {
  extractPluginsConfig,
  getAbsoluteUrl,
  getPluginConfig,
  hasPlugin,
  hasPollsPluginInContent
};
//# sourceMappingURL=utils.js.map
